<template>
	<div class="fund-card-stats box" v-if="fundStats.length > 0">
		<slot name="customStatFirst" />

		<div
			class="col sm-auto fund-card-stat"
			v-for="(stat, statIndex) in fundStats"
			:key="statIndex"
		>
			<div class="fund-card-stat-box-wrapper">
				<template v-if="stat.length > 1">
					<TabView :mobileSelect="false" :tabs="stat" :id="stat.id">
						<template v-for="(tab, tabIndex) in stat" #[tab.slotName]>
							<div :key="tabIndex">
								<div class="h4" v-html="stat[tabIndex].value" />
								<span class="caption" v-html="stat[tabIndex].caption" />
							</div>
						</template>
					</TabView>
				</template>

				<!-- If stat array contains only one item, label should not be clickable -->
				<template v-else>
					<span class="eyebrow">{{ stat[0].label }}</span>
					<div class="h4" v-html="stat[0].value" />
					<span class="caption" v-html="stat[0].caption" />
				</template>
			</div>
		</div>

		<slot name="customStatLast" />
	</div>
</template>

<script>
import { TabView } from "../../tab-view-v2";

export default {
	name: "FundCardStatbox",

	components: {
		TabView
	},

	props: {
		fundStats: {
			type: Array
		}
	}
};
</script>

<style lang="scss">
.fund-card {
	&-stats {
		border-top: 2px solid $color--lighter-gray;
		justify-content: space-between;
		padding: 32px 32px 8px;

		@include from-md() {
			padding: 32px 18px 8px;
		}

		p {
			display: table;
		}

		.eyebrow {
			display: inline-block;
			vertical-align: top;

			.inactive-label {
				color: inherit;
				padding-top: 8px;
				padding-bottom: 8px;

				&:hover {
					color: #808080;
				}
			}

			.active-label {
				text-decoration: underline;
				color: inherit;
				padding-top: 8px;
				padding-bottom: 8px;
			}
		}

		.stat-label-container {
			display: flex;
		}

		.pipe {
			float: right;
		}
	}

	& &-stats {
		.tabs-bar {
			margin-bottom: 0;

			.tabs {
				border-bottom: none;

				.tab-view-button-wrapper {
					margin: 0 3px 0 0;
				}

				.tab-view-button-wrapper + .tab-view-button-wrapper {
					&:before {
						font-size: 11px;
						content: "| ";
						vertical-align: top;
						position: relative;
						top: -3px;
					}
				}

				.tab-view-button-wrapper.active {
					border-bottom: none;
				}
			}
		}

		.tab-view-button {
			display: inline-block;
			font-size: 11px;
			letter-spacing: 0.09091em;
			line-height: 1.1;
			text-transform: uppercase;
			margin-bottom: 12px;
			padding: 0;
			vertical-align: top;

			&.active {
				text-decoration: underline;
				font-weight: inherit;
			}
		}
	}

	&-stat {
		&.col {
			margin-bottom: 24px;
			flex: 0 1 auto;
			min-width: 130px;
		}
	}
}
</style>
